import type { createStore } from "jotai";
import { isCookieConsentUnset } from "./components/CookieBanner/consent";
import { appendCrossDomainStorageValue } from "./helpers/crossDomainStorage";
import { onesaasConsentAtom } from "./portals/messagemedia/onesaas-consent-cookie";

interface UtmParameters {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  gclid?: string;
}

const isUtmParameters = (key: string): key is keyof UtmParameters =>
  key.startsWith("utm_") || key === "gclid";

const getUtmParametersFromUrl = (): UtmParameters => {
  const url = new URL(window.location.href);
  const utmParams: UtmParameters = {};

  url.searchParams.forEach((value, key) => {
    if (isUtmParameters(key)) {
      utmParams[key] = value;
      url.searchParams.delete(key);
    }
  });

  window.history.replaceState({}, "", url);

  return utmParams;
};

export const storeUtmParametersInCookie = async (
  store: ReturnType<typeof createStore>
) => {
  try {
    const utmParams = getUtmParametersFromUrl();

    const unsub = store.sub(onesaasConsentAtom, async () => {
      try {
        const atomValue = store.get(onesaasConsentAtom);
        if (!isCookieConsentUnset(atomValue)) {
          for (const [key, value] of Object.entries(utmParams)) {
            document.cookie = `${key}=${value}`;
            await appendCrossDomainStorageValue(key, value);
          }
          unsub();
        }
      } catch (error) {
        console.error("Failed to handle UTM param", error);
      }
    });
  } catch (error) {
    console.error("Failed to handle UTM param", error);
  }
};
